(() => {
  'use strict';
  document.querySelector('.icc-privacy-link a')?.addEventListener('click', event => {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    window.privacyBanner.showPreferences();
  });
  const dialog = document.getElementById('icc-art-viewer');
  if (!dialog || !dialog.showModal || dialog.dataset.bound) return;
  const stage = dialog.querySelector('.icc-art-stage');
  const pages = dialog.querySelector('[data-icc-pages]');
  if (!pages) return;
  dialog.dataset.bound = 'v3';
  const close = dialog.querySelector('[data-icc-close]');
  const status = dialog.querySelector('[data-icc-art-status]');
  const original = dialog.querySelector('[data-icc-original]');
  const output = dialog.querySelector('[data-icc-scale]');
  const minus = dialog.querySelector('[data-icc-minus]');
  const plus = dialog.querySelector('[data-icc-plus]');
  const fit = dialog.querySelector('[data-icc-fit]');
  const full = dialog.querySelector('[data-icc-size]');
  let saved, opener, sources = [], originalSource, scale = 1, originalMode = false, baseWidth = 0;
  let historyKey = null, closing = false;
  const positions = new Map();
  const width = () => Math.max(1, Math.min(900, stage.clientWidth - 24));
  const anchor = () => ({
    x: (stage.scrollLeft + stage.clientWidth / 2 - pages.offsetLeft) / Math.max(1, pages.offsetWidth),
    y: (stage.scrollTop + stage.clientHeight / 2) / Math.max(1, pages.offsetHeight)
  });
  const place = point => {
    stage.scrollLeft = point.x * pages.offsetWidth + pages.offsetLeft - stage.clientWidth / 2;
    stage.scrollTop = point.y * pages.offsetHeight - stage.clientHeight / 2;
  };
  const setScale = (next, preserve = true) => {
    const point = preserve ? anchor() : null;
    scale = Math.max(0.25, Math.min(6, next));
    baseWidth = width();
    pages.style.width = `${Math.round(baseWidth * scale)}px`;
    output.textContent = `${Math.round(scale * 100)}%`;
    minus.disabled = scale <= 0.25;
    plus.disabled = scale >= 6;
    if (point) place(point);
  };
  const render = async () => {
    const selected = originalMode ? [originalSource] : sources;
    pages.replaceChildren(...selected.map(source => {
      const img = document.createElement('img');
      img.src = source.src;
      img.alt = source.alt;
      if (source.width && source.height) { img.width = source.width; img.height = source.height; }
      img.draggable = false;
      img.addEventListener('error', () => { status.textContent = dialog.dataset.error; });
      return img;
    }));
    original.setAttribute('aria-pressed', String(originalMode));
    setScale(1, false);
    stage.scrollTo(0, 0);
    await Promise.allSettled([...pages.querySelectorAll('img')].map(img => img.decode()));
  };
  const remember = () => { if (dialog.open && originalSource) positions.set(originalSource.src, {scale, originalMode, top:stage.scrollTop, left:stage.scrollLeft}); };
  const restore = () => {
    if (!saved) return;
    const prior = saved;
    saved = null;
    if (prior.style === null) document.body.removeAttribute('style');
    else document.body.setAttribute('style', prior.style);
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(prior.x, prior.y);
    opener?.isConnected && opener.focus({preventScroll:true});
    document.documentElement.style.scrollBehavior = prior.scrollBehavior;
    history.scrollRestoration = prior.scrollRestoration;
    historyKey = null;
    closing = false;
  };
  const requestClose = () => {
    if (closing || !dialog.open) return;
    remember();
    closing = true;
    if (historyKey && history.state?.iccReader === historyKey) history.back();
    else dialog.close();
  };
  document.querySelectorAll('[data-icc-enlarge]').forEach(link => {
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', dialog.id);
    link.removeAttribute('target');
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-icc-enlarge]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (dialog.open) return;
    opener = link;
    const comic = link.closest('icc-comic-engine, icc-comic-pilot');
    const panelImages = comic ? [...comic.querySelectorAll('[data-ce-panel] img, .icc-panels figure img')] : [];
    const isFullArt = link.hasAttribute('data-stage-full');
    sources = panelImages.map(img => ({src:img.getAttribute('src'),alt:img.alt,width:Number(img.getAttribute('width')),height:Number(img.getAttribute('height'))}));
    const clickedImage = isFullArt ? null : link.querySelector('img');
    const fullLink = comic?.querySelector('.ce-full, .icc-comic-head [data-icc-enlarge]');
    originalSource = {src:fullLink?.href || link.href,alt:dialog.dataset.fullAlt};
    if (!sources.length) sources = [{src:link.href,alt:clickedImage?.alt || dialog.dataset.fullAlt}];
    originalMode = isFullArt;
    status.textContent = dialog.dataset.help;
    saved = {x:scrollX,y:scrollY,style:document.body.getAttribute('style'),scrollBehavior:document.documentElement.style.scrollBehavior,scrollRestoration:history.scrollRestoration};
    history.scrollRestoration = 'manual';
    document.body.style.position = 'fixed';
    document.body.style.top = `${-saved.y}px`;
    document.body.style.left = `${-saved.x}px`;
    document.body.style.width = '100%';
    historyKey = `reader-${Date.now()}`;
    const url = new URL(location.href);
    url.hash = 'comic-reader';
    try { history.pushState({...history.state,iccReader:historyKey},'',url); }
    catch (_) { historyKey = null; }
    dialog.showModal();
    close.focus({preventScroll:true});
    const previous = positions.get(originalSource.src);
    if (previous && !clickedImage) originalMode = previous.originalMode;
    await render();
    if (!dialog.open) return;
    if (clickedImage) {
      const index = panelImages.indexOf(clickedImage);
      stage.scrollTop = pages.children[Math.max(0,index)]?.offsetTop || 0;
    } else if (previous) {
      setScale(previous.scale,false);
      stage.scrollTo(previous.left,previous.top);
    }
  });
  plus.addEventListener('click', () => setScale(scale * 1.5));
  minus.addEventListener('click', () => setScale(scale / 1.5));
  fit.addEventListener('click', () => setScale(1));
  full.addEventListener('click', () => setScale(Math.max(...[...pages.querySelectorAll('img')].map(img => img.naturalWidth)) / width()));
  original.addEventListener('click', async () => { originalMode = !originalMode; await render(); });
  close.addEventListener('click', requestClose);
  dialog.addEventListener('cancel', event => {event.preventDefault();requestClose();});
  dialog.addEventListener('close', restore);
  window.addEventListener('popstate', () => { if (dialog.open && history.state?.iccReader !== historyKey) { remember(); dialog.close(); } });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const stops = [...dialog.querySelectorAll('button:not(:disabled),[tabindex="0"]')];
    const first = stops[0], last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
  });
  new ResizeObserver(() => {
    if (!dialog.open || Math.abs(width() - baseWidth) < 1) return;
    const oldHeight = Math.max(1,pages.offsetHeight);
    const ratio = stage.scrollTop / oldHeight;
    setScale(scale,false);
    stage.scrollTop = ratio * pages.offsetHeight;
  }).observe(stage);
})();
